import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { Checkbox, Chip } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { COMPANY_PRODUCT_SELECT } from '@tenant/utility/constants/enum';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const CompanyProductSelect = ({ error, helperText, isMultiple = false, value = [], ...props }) => {
	return (
		<Autocomplete
			options={COMPANY_PRODUCT_SELECT}
			autoHighlight
			multiple={isMultiple}
			disableCloseOnSelect={isMultiple}
			value={value}
			getOptionLabel={option => option.label}
			isOptionEqualToValue={(option, value) => {
				return option?.value === value?.value;
			}}
			renderOption={(props, option, { selected }) => (
				<Box component="li" {...props} key={option.value}>
					{isMultiple && <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8 }} checked={selected} />}
					{option.label}
				</Box>
			)}
			renderTags={(tagValue, getTagProps) =>
				tagValue.map((option, index) => {
					return <Chip label={option.label} {...getTagProps({ index })} key={option.value} />;
				})
			}
			renderInput={params => <TextField {...params} error={error} helperText={helperText} placeholder={isMultiple ? 'Select company products' : 'Select company product'} />}
			{...props}
		/>
	);
};

export default React.memo(CompanyProductSelect);

CompanyProductSelect.propTypes = {
	error: PropTypes.bool,
	helperText: PropTypes.string,
	isMultiple: PropTypes.bool,
	value: PropTypes.array
};
